
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import scroll from '@/mixins/scroll';
import Address from '@/views/shelf/components/address.vue'
import Price from '@/components/Price/index.vue'
import {
  getStoreOrder,
} from '@/api/industryMall';
// import { ShopOrderInfoDto, OrderDelDTO } from "@/views/industryMall/order/order.ts";
import { Getter } from 'vuex-class';
import { getCurrentOrder, getTomorrowOrder, getHistoryOrder, getOrderDtl } from '@/api/ccx'

@Component({
  name: 'SalesSilp',
  components: {
    Address,
    Price
  }
})
export default class SalesSilp extends Mixins(scroll) {
  @Getter companyId!: string;
  @Getter whiteStrips!: number;
  @Getter topSafetyHeight!: number
  @Prop({ default: '' }) searchKey?: string;
  tabKeys = '';
  showDetail = false; // 展示明细
  error = false;

  tabActions = [
    { text: '今日', value: '1', id: 1 },
    { text: '明日', value: '2', id: 2 }, // 和接口确认 value取值
    { text: '历史', value: '3', id: 3 },
  ];

  refreshing = false;
  loading = false;
  finished = false;
  params: any = {
    storeId: '',
    // 订单编号
    orderId: '',
    // 手机号
    receiveMobile: '',
    // 商品名称
    goodsName: '',
    // 收货人姓名
    receiveMan: '',
    pageIndex: 1,
    pageSize: 20,
  };
  orderList = [];
  controller: any;
  clickedItemIndex = 0;
  isActivated = false;
  dataDetail: any = {}; // 明细数据
  Api: any = getCurrentOrder;
  sftpUrl = ''

  created() {
    this.params.storeId = this.companyId;
    const { orderType, payType } = this.$route.query;
    // console.log('orderType', orderType)
    if (orderType || payType) {
      this.tabKeys = (orderType as string) || (payType as string);
    }
    // this.getOrderList()
  }

  mounted() {
    this.$addScrollListener('.van-tabs__content');
    this.sftpUrl = this.$store.state.user.sftpUrl
  }

  closeShowDetail() {
    this.showDetail = false;
  }

  activated() {
    if (this.isActivated) {
      this.handleActivated();
      this.$setScrollY();
    } else {
      this.isActivated = true;
    }
  }

  deactivated() {
    this.$removeScrollListener();
  }

  /**
   * @description 从订单详情返回刷新当前页数据，当前页之后的数据清除
   **/
  handleActivated() {
    const pageIndex =
      Math.trunc(this.clickedItemIndex / this.params.pageSize) + 1;
    const params = { ...this.params, pageIndex };
    getStoreOrder(params).then((res) => {
      if (pageIndex > 1) {
        const preData = this.orderList.slice(
          0,
          (pageIndex - 1) * this.params.pageSize
        );
        const data = preData.concat(res.data.records);
        this.orderList = JSON.parse(JSON.stringify(data));
      } else {
        this.orderList = res.data.records;
      }
      this.params.pageIndex = pageIndex;
      if (Number(pageIndex) >= res.data.totalPages) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    });
  }

  @Watch('tabKeys')
  handleTabKeys() {
    if (this.tabKeys === '1') {
      this.Api = getCurrentOrder
    } else if (this.tabKeys === '2') {
      this.Api = getTomorrowOrder
    } else {
      this.Api = getHistoryOrder
    }
    this.params.pageIndex = 1;
    console.log('tabKeys', this.tabKeys, this.params.pageIndex);
    this.finished = false;
    this.loading = true;
    this.orderList = [];
    if (this.controller) {
      console.log('123', this.controller);
      this.controller.abort();
    }
    this.getOrderList();
  }

  /**
   * @description 关联退单
   *
   */
  goReturnList(list) {
    // 确保订单列表页面刷新
    this.$eventBus.$emit('refreshStatus', {
      status: '退款申请',
      orderId: list.orderId,
    });
  }

  getOrderList() {
    this.Api({ ...this.params })
      .then((res) => {
        this.error = false;
        if (this.refreshing) {
          this.orderList = [];
        }

        const orderList = this.orderList.concat(res.data.records) || [];
        this.orderList = JSON.parse(JSON.stringify(orderList));
        if (Number(this.params.pageIndex) >= res.data.totalPages) {
          console.log("123434---------");
          this.finished = true;
        } else {
          this.finished = false;
        }
      })
      .catch((err) => {
        this.error = true;
        this.params.pageIndex = 0;
      })
      .finally(() => {
        this.loading = false
        this.refreshing = false
      });
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1;
    this.refreshing = true;
    if (this.controller) {
      this.controller.abort();
    }
    this.getOrderList();
  }

  /**
   * 上拉加载更多
   */
  onLoad() {
    console.log('1234');
    // this.loading = true
    this.params.pageIndex++;
    this.getOrderList();
  }
  showDetails(item) {
    getOrderDtl({ storeId: this.companyId, orderId: item.orderId }).then(res => {
      this.showDetail = true;
      this.dataDetail = res.data;
    })
  }

  handleDate (time: string) {
    if (!time) return ''
    let arr = time.split('-')
    console.log(arr);
    return `${arr[0]}年${arr[1]}月${arr[2]}日`
  }

  showGoodsList(list: any) {
    (this.$refs.goodsList as any).showPop(list);
  }
}
